import { Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { CSSProperties } from "@mui/styled-engine";

type Prop = {
  children?: React.ReactNode;
  to: string;
  underline?: "none" | "always" | "hover" | undefined;
  sx?: CSSProperties;
  typographySx?: CSSProperties;
};

export const ClickableTypography = ({ children, to, sx, typographySx, underline }: Prop) => {
  const baseSx = {
    cursor: "pointer",
  };

  const baseTypographySx = {};

  return (
    <Link component={RouterLink} to={to} sx={sx ? { ...sx, ...baseSx } : baseSx}>
      <Typography sx={typographySx ? { ...typographySx, ...baseTypographySx } : baseTypographySx}>
        {children}
      </Typography>
    </Link>
  );
};
